import { useEffect, useRef, useState } from 'react';
import * as S from './styles';
import {
    CheckCircle,
    X,
    CaretDown,
    CaretUp,
    Info,
    Warning
} from '@phosphor-icons/react';

interface IToast {
    status: number,
    message: string,

    openToast: boolean,
    closeToast: () => void,
}

export default function Toast({
    openToast,
    closeToast,
    status,
    message
}: IToast) {
    const [isSubMenuVisible, setSubMenuVisible] = useState(false);
    const [progress, setProgress] = useState(100);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const [toastState] = useState([
        {
            title: 'Sucesso!',
            subtitle: 'Operação realizada com sucesso.',
            status: [200, 201],
            icon: <CheckCircle size={24} />,
            classes: 'active'
        },
        {
            title: 'Erro!',
            subtitle: 'Ocorreu um erro na operação.',
            status: [400, 404, 422],
            icon: <Warning size={24} />,
            classes: 'erro'
        },
        {
            title: 'Aviso!',
            subtitle: 'Algo não saiu como esperado.',
            status: [500],
            icon: <Info size={24} />,
            classes: 'attention'
        }
    ]);

    // Encontrar a config correspondente ao status recebido
    const toastConfig = toastState.find(config => config.status.includes(status));

    // Controle da barra de tempo
    useEffect(() => {
        if (!openToast) return;

        let start = Date.now();
        let duration = 3000; // 3 segundos

        const step = () => {
            const now = Date.now();
            const elapsed = now - start;
            const percent = Math.max(0, 100 - (elapsed / duration) * 100);
            setProgress(percent);

            if (percent <= 0) {
                closeToastModal();
                clearInterval(intervalRef.current!);
            }
        };

        if (!isSubMenuVisible) {
            start = Date.now();
            intervalRef.current = setInterval(step, 100);
        }

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [openToast, isSubMenuVisible, closeToast]);

    const closeToastModal = () => {
        closeToast();
        setSubMenuVisible(false);
    }

    if (openToast && toastConfig) {
        return (
            <S.Container>
                <S.Content>
                    <S.Head>
                        <S.HeadLeft className={toastConfig.classes}>
                            {toastConfig.icon}
                            <S.Title>{toastConfig.title}</S.Title>
                        </S.HeadLeft>

                        <S.ContentButton>
                            <S.Button
                                onClick={() => setSubMenuVisible(!isSubMenuVisible)}
                            >
                                {
                                    isSubMenuVisible ?
                                        <CaretUp size={20} />
                                        :
                                        <CaretDown size={20} />
                                }
                            </S.Button>
                            <S.Button onClick={closeToastModal} >
                                <X size={20} />
                            </S.Button>
                        </S.ContentButton>
                    </S.Head>

                    <S.Body className={isSubMenuVisible ? 'visible' : ''}>
                        <S.SubTitle>
                            {message}
                        </S.SubTitle>
                    </S.Body>

                    <S.Footer>
                        <S.SubTitle>{toastConfig.subtitle}</S.SubTitle>
                        <S.ContentProgress>
                            <S.ProgressBar
                                className={toastConfig.classes}
                                style={{ width: `${progress}%` }}
                            />
                        </S.ContentProgress>
                    </S.Footer>
                </S.Content>
            </S.Container>
        )

    } return null;
}